import React from 'react';
import {NotificationBanner} from 'app/components/banner/NotificationBanner';
import {PromoBanner} from 'app/components/banner/PromoBanner';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';

const AppShellBanner = () => {
  const {pushSupport, notificationNoSupportBanner} = useSelector(selectCurrentUser);

  let Banner = null;
  const initialBannerShowUp = !pushSupport && notificationNoSupportBanner === 0;

  if (initialBannerShowUp) {
    Banner = <PromoBanner />;
  } else if (pushSupport) {
    Banner = <NotificationBanner />;
  }

  return Banner;
};

export default AppShellBanner;
